import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import services from 'services';
import { RootState } from 'types/store';

export const getCashPaymentAvailability = createAsyncThunk(
    'events/getCashPaymentAvailability',
    async (_, { getState }) => {
        const { cart } = getState() as RootState;
        if (cart.data) {
            const response = await services.paymentAvailability.getCashPaymentAvailability(
                cart.data.id,
            );
            return response;
        }
    },
);

export type PaymentAvailability = {
    // add more paymentTypes if needed
    paymentType: 'cash';
    processorAvaialable: boolean;
    reason?: string;
};

export type PaymentAvailabilityState = {
    status: 'idle' | 'pending' | 'ok' | 'error';
    data: PaymentAvailability[] | null;
    error: SerializedError | null;
};

const initialState: PaymentAvailabilityState = {
    status: 'idle',
    data: [],
    error: null,
};

const slice = createSlice({
    name: 'paymentAvailability',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getCashPaymentAvailability.pending, (state: PaymentAvailabilityState) => {
            state.status = 'pending';
        });
        builder.addCase(
            getCashPaymentAvailability.fulfilled,
            (state: PaymentAvailabilityState, action) => {
                state.status = 'ok';
                state.data = [
                    {
                        paymentType: 'cash',
                        processorAvaialable: action.payload?.processorAvaialable ?? false,
                        reason: action.payload?.reason,
                    },
                ];
            },
        );
        builder.addCase(getCashPaymentAvailability.rejected, (state: PaymentAvailabilityState) => {
            state.status = 'error';
            state.data = [];
        });
    },
});

export default slice;
